import { useMemo } from 'react';
import type { EventPageFragment } from '@graphql/fragments/event.page.graphql.generated';
import { filterMigratedLegacyPages } from '@shared/utils/migratedCustomPages';
import { useMigratedCustomPageFeatureFlags } from '@shared/hooks/useMigratedCustomPageFeatureFlags/useMigratedCustomPageFeatureFlags';

interface UseFilterMigratedLegacyPagesReturn {
  readonly filteredPages: ReadonlyArray<EventPageFragment>;
  readonly isLoading: boolean;
}

// Wraps `filterMigratedLegacyPages` and feeds it the per-slug flag state so rollback-aware
// migrations (registrylinks, travel) flip on flag-off. See `migratedCustomPages.ts`.
export const useFilterMigratedLegacyPages = (pages: ReadonlyArray<EventPageFragment>): UseFilterMigratedLegacyPagesReturn => {
  const { isMigratedCustomPageEnabled, isLoading } = useMigratedCustomPageFeatureFlags();
  const filteredPages = useMemo(
    () => filterMigratedLegacyPages(pages, { isMigratedCustomPageEnabled, isFeatureFlagsLoading: isLoading }),
    [pages, isMigratedCustomPageEnabled, isLoading],
  );
  return { filteredPages, isLoading };
};
